function checkType(value, type, error) {
    const typeIsArray = type === 'array';
    const valueIsArray = Array.isArray(value);
    if (typeIsArray || valueIsArray) {
        if (valueIsArray !== typeIsArray)
            throw new Error(error);
    }
    else {
        if (typeof value !== type)
            throw new Error(error);
    }
}

export { checkType as c };
